import { motion, AnimatePresence } from "framer-motion";

const IntroSplash = ({ show }) => (
  <AnimatePresence>
    {show && (
      <motion.div
        data-testid="intro-splash"
        className="fixed inset-0 z-[70] grid place-items-center bg-[#FAF7F2]"
        exit={{ y: "-100%" }}
        transition={{ duration: 0.65, ease: [0.76, 0, 0.24, 1] }}
      >
        <motion.img
          src="/logo.png"
          alt="KSR Poultry Farms"
          className="h-44 w-44 rounded-full shadow-[0_20px_60px_rgba(107,29,47,0.25)] sm:h-56 sm:w-56"
          initial={{ scale: 0.55, opacity: 0, rotate: -6 }}
          animate={{ scale: 1, opacity: 1, rotate: 0 }}
          transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
        />
      </motion.div>
    )}
  </AnimatePresence>
);

export default IntroSplash;
